module.exports = __webpack_public_path__ + "static/media/german-number-21-97.54a0a124.PNG";